class FiltersV2 {
  static mobileFocusTrapFallback = null;
  static mobileAriaHiddenElements = [];

  static getManagedForms() {
    return document.querySelectorAll(
      '#FiltersFormDesktop, #FiltersFormMobile, #FiltersSortForm, #FiltersSortDrawerForm, #FiltersPillsForm'
    );
  }

  constructor(formEl) {
    this.formEl = formEl;
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    formEl.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = document.getElementById('FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static init() {
    FiltersV2.getManagedForms().forEach((form) => {
      if (!form.dataset.filtersV2Init) {
        form.dataset.filtersV2Init = 'true';
        new FiltersV2(form);
      }
    });

    FiltersV2.initFilterRemoveLinks();
    FiltersV2.initPriceRangeInputs();
    FiltersV2.initMobileFacetsUI();
  }

  static initFilterRemoveLinks() {
    document.querySelectorAll('[data-filter-remove] a').forEach((link) => {
      if (!link.dataset.filtersRemoveInit) {
        link.dataset.filtersRemoveInit = 'true';
        link.setAttribute('role', 'button');
        link.setAttribute('data-action', 'clear-filters');
        link.addEventListener('click', (event) => {
          event.preventDefault();
          FiltersV2.toggleActiveFacets();
          const url = link.href.indexOf('?') === -1
            ? ''
            : link.href.slice(link.href.indexOf('?') + 1);
          FiltersV2.renderPage(url);
        });
        link.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            link.click();
          }
        });
      }
    });
  }

  static initPriceRangeInputs() {
    document.querySelectorAll('[data-price-range]').forEach((el) => {
      if (el.dataset.priceRangeInit) return;
      el.dataset.priceRangeInit = 'true';

      const inputs = el.querySelectorAll('input');
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (!minInput || !maxInput) return;

      const setMinMax = () => {
        if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('data-min', 0);
        if (maxInput.value === '') minInput.setAttribute('data-max', minInput.getAttribute('data-max'));
      };

      const adjustToValid = (input) => {
        const value = Number(input.value);
        const min = Number(input.getAttribute('data-min'));
        const max = Number(input.getAttribute('data-max'));
        if (value < min) input.value = min;
        if (value > max) input.value = max;
      };

      inputs.forEach((input) => {
        input.addEventListener('change', () => { adjustToValid(input); setMinMax(); });
        input.addEventListener('keydown', (e) => {
          if (e.metaKey) return;
          const pattern = /[0-9]|\.| |,|'|Tab|Backspace|Enter|Arrow|Delete|Escape/;
          if (!e.key.match(pattern)) e.preventDefault();
        });
      });

      setMinMax();
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FiltersV2.searchParamsInitial;
      if (searchParams === FiltersV2.searchParamsPrev) return;
      FiltersV2.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => FiltersV2.init());
    } else {
      FiltersV2.init();
    }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('[data-filter-remove] a').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
    var activeFacetsDesktop = document.querySelector('.active-facets-desktop');
    
    if (activeFacetsDesktop) {
      const hasFacetRemoveV2 = activeFacetsDesktop.querySelectorAll('[data-filter-remove]').length > 1;
      if (!hasFacetRemoveV2) {
        activeFacetsDesktop.classList.remove('active-facets-desktop--visible');
      }
    }
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FiltersV2.searchParamsPrev = searchParams;
    const sections = FiltersV2.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, [data-filters-form] .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FiltersV2.filterData.some(filterDataUrl)
        ? FiltersV2.renderSectionFromCache(filterDataUrl, event)
        : FiltersV2.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FiltersV2.updateURLHash(searchParams);
    //window.location = window.location;
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FiltersV2.filterData = [...FiltersV2.filterData, { html, url }];
        FiltersV2.renderFilters(html, event);
        FiltersV2.renderProductGridContainer(html);
        FiltersV2.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FiltersV2.filterData.find(filterDataUrl).html;
    FiltersV2.renderFilters(html, event);
    FiltersV2.renderProductGridContainer(html);
    FiltersV2.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    // The sort form lives inside ProductGridContainer and was just replaced, so
    // re-bind it (init() is idempotent via data-filtersV2Init guards).
    FiltersV2.init();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }

    if (isMobile) {
      const mobileCount = document.querySelector('.mobile-facets__count');

      if (mobileCount) {
        mobileCount.innerHTML = count;
      }
    }
    
    

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, [data-filters-form] .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FiltersFormDesktop .js-filter, #FiltersFormMobile .js-filter, #FiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FiltersFormDesktop .js-filter, #FiltersFormMobile .js-filter, #FiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FiltersV2.renderActiveFacets(parsedHTML);
    FiltersV2.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FiltersV2.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FiltersV2.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `[data-mobile-filter-toggle], .mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      var currentActiveFacetsElement = document.querySelector(selector);
      if (!activeFacetsElement) return;
      currentActiveFacetsElement.innerHTML = activeFacetsElement.innerHTML;
      currentActiveFacetsElement.classList.add('active-facets-desktop--visible');
    });

    FiltersV2.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    FiltersV2.init();
  }

  static initMobileFacetsUI() {
    const setExpanded = (button, isExpanded) => {
      if (!button) return;
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    };

    document.querySelectorAll('[data-mobile-facets]').forEach((wrapper) => {
      const toggleButton = wrapper.querySelector('.mobile-facets__toggle');
      const panel = wrapper.querySelector('[data-mobile-facets-panel]');
      const disclosure = wrapper.querySelector('[data-mobile-facets-disclosure]');

      if (toggleButton && panel && !toggleButton.dataset.mobileFacetsInit) {
        toggleButton.dataset.mobileFacetsInit = 'true';

        const setPanelState = (isOpen) => {
          panel.hidden = !isOpen;
          setExpanded(toggleButton, isOpen);
          wrapper.classList.toggle('mobile-facets--open', isOpen);
          if (disclosure) {
            disclosure.classList.toggle('menu-opening', isOpen);
          }
          document.body.classList.toggle('overflow-hidden-mobile', isOpen);

          const firstFocusable = panel.querySelector(
            '.mobile-facets__close, .mobile-facets__close-button, [data-mobile-filter-toggle], button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          FiltersV2.focusTrapMobile({
            isOpen,
            panel,
            toggleButton,
            initialFocusElement: firstFocusable || panel,
          });
        };

        toggleButton.addEventListener('click', () => {
          setPanelState(panel.hidden);
        });

        wrapper.querySelectorAll('.mobile-facets__close').forEach((closeButton) => {
          if (closeButton.dataset.mobileFacetsInit) return;
          closeButton.dataset.mobileFacetsInit = 'true';

          closeButton.addEventListener('click', (event) => {
            event.preventDefault();
            setPanelState(false);
          });
        });
      }

      wrapper.querySelectorAll('[data-mobile-filter-toggle]').forEach((button) => {
        if (button.dataset.mobileFilterInit) return;
        button.dataset.mobileFilterInit = 'true';

        button.addEventListener('click', () => {
          const targetId = button.getAttribute('aria-controls');
          const target = targetId ? wrapper.querySelector(`#${targetId}`) : null;
          if (!target) return;

          const willOpen = target.hidden;
          target.hidden = !willOpen;
          setExpanded(button, willOpen);

          const details = button.closest('.mobile-facets__details');
          if (details) {
            details.classList.toggle('menu-opening', willOpen);
          }
        });
      });

      wrapper.querySelectorAll('.mobile-facets__close-button').forEach((closeButton) => {
        if (closeButton.dataset.mobileFilterInit) return;
        closeButton.dataset.mobileFilterInit = 'true';

        closeButton.addEventListener('click', () => {
          const submenu = closeButton.closest('.mobile-facets__submenu');
          if (!submenu || !submenu.id) return;

          submenu.hidden = true;
          const details = closeButton.closest('.mobile-facets__details');
          if (details) {
            details.classList.remove('menu-opening');
          }
          const toggle = wrapper.querySelector(`[data-mobile-filter-toggle][aria-controls="${submenu.id}"]`);
          setExpanded(toggle, false);
        });
      });
    });
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      const wasExpanded = !targetFacetsList.hidden;
      const listId = targetFacetsList.id;

      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;

      const refreshedList = listId ? document.getElementById(listId) : target.querySelector('.mobile-facets__list');
      if (!refreshedList) return;

      refreshedList.hidden = !wasExpanded;

      if (listId) {
        const toggleButton = target.querySelector(`[data-mobile-filter-toggle][aria-controls="${listId}"]`);
        if (toggleButton) {
          toggleButton.setAttribute('aria-expanded', wasExpanded ? 'true' : 'false');
        }
      }

      target.classList.toggle('menu-opening', wasExpanded);
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FiltersV2.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = FiltersV2.getManagedForms();
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FiltersSortForm' || form.id === 'FiltersFormDesktop' || form.id === 'FiltersSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FiltersV2.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FiltersV2.renderPage(url);
  }

  static focusTrapMobile({ isOpen, panel, toggleButton, initialFocusElement }) {
    if (!panel || !toggleButton) return;

    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    if (isMobile) {
      const backgroundSelectors = ['#ProductGridContainer', 'footer', '.utility-bar', '.announcement-bar-section', '.section-header','.collection-hero__title','.mobile-facets__open-wrapper','.active-facets__button-remove'];

      if (isOpen) {
        FiltersV2.mobileAriaHiddenElements = [];

        backgroundSelectors.forEach((selector) => {
          document.querySelectorAll(selector).forEach((element) => {
            //console.log('Element targeted to be aria-hidden overlaps with the panel, skipping aria-hidden toggle for this element.!!!!!!', element);
            if (panel.contains(element) || element.contains(panel)) return;
            //console.log('Element targeted to be aria-hidden overlaps with the panel, skipping aria-hidden toggle for this element.', element);
            FiltersV2.mobileAriaHiddenElements.push({
              element,
              previousAriaHidden: element.getAttribute('aria-hidden'),
            });

            element.setAttribute('aria-hidden', 'true');
          });
        });
      } else {
        FiltersV2.mobileAriaHiddenElements.forEach(({ element, previousAriaHidden }) => {
          if (!element) return;

          if (previousAriaHidden === null) {
            element.removeAttribute('aria-hidden');
          } else {
            element.setAttribute('aria-hidden', previousAriaHidden);
          }
        });

        FiltersV2.mobileAriaHiddenElements = [];
      }
    }

    if (isOpen) {
      if (typeof trapFocus === 'function') {
        trapFocus(panel, initialFocusElement || panel);
      } else {
        const focusableSelector =
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
        const focusable = Array.from(panel.querySelectorAll(focusableSelector)).filter(
          (el) => !el.hasAttribute('hidden') && el.offsetParent !== null
        );

        if (focusable.length) {
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          const trapHandler = (event) => {
            if (event.key !== 'Tab') return;

            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          };

          panel.addEventListener('keydown', trapHandler);
          FiltersV2.mobileFocusTrapFallback = { panel, trapHandler };
        }
      }

      if (initialFocusElement && typeof initialFocusElement.focus === 'function') {
        initialFocusElement.focus();
      }
      return;
    }

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(toggleButton);
    }

    if (FiltersV2.mobileFocusTrapFallback) {
      const { panel: trappedPanel, trapHandler } = FiltersV2.mobileFocusTrapFallback;
      trappedPanel.removeEventListener('keydown', trapHandler);
      FiltersV2.mobileFocusTrapFallback = null;
    }

    toggleButton.focus();
  }
}

FiltersV2.filterData = [];
FiltersV2.searchParamsInitial = window.location.search.slice(1);
FiltersV2.searchParamsPrev = window.location.search.slice(1);
FiltersV2.setListeners();
